import { cn } from '@/shared/lib'
import { Checkbox } from '@/shared/ui/checkbox'
import { type Employee, shortName } from '../model/schema'

interface EmployeePickerProps {
  label: string
  employees: Employee[]
  selected: string[]
  onChange: (ids: string[]) => void
  hint?: string
}

/**
 * Кого назначить. Пустой выбор — законное состояние: время можно занять «ничьё»
 * (`OccupiesTime` — такое дело видно в командной сетке, но ни в чьей колонке).
 */
export function EmployeePicker({
  label,
  employees,
  selected,
  onChange,
  hint,
}: EmployeePickerProps) {
  const toggle = (id: string) => {
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id])
  }

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="label mb-2">{label}</legend>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5">
        {employees.map((employee) => (
          <Checkbox
            key={employee.id}
            checked={selected.includes(employee.id)}
            onChange={() => toggle(employee.id)}
            label={
              <span
                className={cn(
                  'text-sm',
                  selected.includes(employee.id) ? 'text-text-primary' : 'text-text-secondary',
                )}
              >
                {shortName(employee)}
              </span>
            }
          />
        ))}
      </div>
      {hint && <span className="text-xs text-text-tertiary">{hint}</span>}
    </fieldset>
  )
}
